import Component from '../core/Component';

export default class MenuOpener extends Component {

    constructor(element) {
        super(element);
    }

    prepare() {
        //
        this.menuElement = document.querySelector('[data-component="Menu"]');
        this.menu = Component.getFromElement(this.menuElement);

        this.element.addEventListener('click', event => {
            if (!document.documentElement.classList.contains('menu-is-opened')) {
                this.open()
            } else {
                this.close()
            }
        })

        document.addEventListener("keydown", (event) => {
            event = event || window.event;
            if (event.keyCode == 27) {
                this.close();
            }
        });
    }

    open() {
        this.menu.component.open();
    }

    close() {
        this.menu.component.close();
    }

}


// WEBPACK FOOTER //
// ./components/MenuOpener.js